<template>
  <div class="pesquisa-container">
    <b-input-group>
      <input
        id="pesquisaLabel"
        type="text"
        :placeholder="placeHolder"
        class="form-control pesquisa-input"
        :value="value"
        @input="$emit('input', $event.target.value)"
      />
      <b-input-group-append
        class="pesquisa-button"
        v-if="isShowButtonSearch"
        v-on="$listeners"
      >
        <b-button>
          <b-icon icon="search"></b-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <b-icon icon="search" class="icone-lupa"></b-icon>
  </div>
</template>

<script>
export default {
  props: {
    placeHolder: String,
    value: String,
    isShowButtonSearch: Boolean,
  },
};
</script>

<style scoped>
.pesquisa-label {
  color: #ffffff;
  font-family: UnimedSlab-SemiBold;
  text-align: center;
}

.pesquisa-input {
  font-family: Roboto;
  padding-right: 40px;
  height: 52px;
}

.pesquisa-button button {
  color: #000;
  width: 100px;
  border-color: #ced4da;
  background-color: #e9ecef;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.pesquisa-button /deep/:hover {
  color: #fff;
  background-color: #b1d34b;
  border-color: #b1d34b;
}

.pesquisa-container {
  position: relative;
}

.icone-lupa {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
  color: var(--text-primary);
}
</style>
